import React from 'react';

const Loader = () => (
    <div className="pageWrapper loading">
        <div>Loading...</div>
        <div><small>If this message persists, please refresh the page.</small></div>
    </div>
);

export default Loader;